export default __webpack_public_path__ + "static/calendar-view-6de0165b7f503f065c4f2dbebb9aaa57.gif";